import { useMemo } from 'react';

import { useDirectoryGetSchemas } from 'api/requests';
import { lodash } from 'helpers';
import { useServerErrorNotify } from 'hooks';
import { useTranslation } from 'libs/i18n';

export const useDirectories = () => {
  const { error, loading, schemas } = useDirectoryGetSchemas();

  const { language } = useTranslation();

  const directories = useMemo(
    () =>
      schemas
        ? lodash.compact(
            schemas?.map((schema) => {
              if (!schema) {
                return null;
              }
              const label = schema.label?.[language] || schema.label?.ru || '';
              return {
                id: schema.name,
                label,
              };
            })
          )
        : undefined,
    [language, schemas]
  );

  useServerErrorNotify(error);

  return { loading, directories };
};
